import styled from 'styled-components';

export const Text = styled.p`
  margin: 0;
  color: #000;
  p {
    white-space: normal !important;
  }
  a {
    font-weight: bold;

    & :hover {
      text-decoration: underline;
    }
  }

  a,
  span {
    margin: 0 0px;
  }
`;

export default Text;
